import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import UserDataServices from "./UserDataServices";
export const getalluserData = createAsyncThunk(
  "userdata/Information",
  async (userId, thunkAPI) => {
    try {
      return await UserDataServices.fetch_All_Data(userId);
    } catch (err) {
      return thunkAPI.rejectWithValue(err);
    }
  }
);

const initialState = {
  error: null,
  status: "idle",
  data: [],
  message: "",
};

export const Signiupuserdata = createSlice({
  name: "userdata",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getalluserData.fulfilled, (state, { payload }) => {
      state.data = payload;
      state.error = null;
      state.status = "succeeded";
    });
    builder.addCase(getalluserData.pending, (state, payload) => {
      state.status = "loading";
      state.error = null;
      state.data = [];
    });
    builder.addCase(getalluserData.rejected, (state, { payload }) => {
      state.status = "failed";
      state.data = [];
      state.error = payload;
    });
  },
});

// Action creators are generated for each case reducer function
export const {} = Signiupuserdata.actions;

export default Signiupuserdata.reducer;
